import React, { useEffect, useState } from "react";
import "./billOfMaterial.scss";
import { TableHeader } from "../../../commons";
import { OutputGoodsHeaders } from "../../../../constant/billOfMaterial";
import {
  BomHeaderType,
  BomOutputType,
  SelectOption,
} from "../../../../commonTypes/billOfMaterial";
import BomTableData from "./BomTableData";
import BomAddMore from "./BomAddMore";
import BomTableheader from "./BomTableHeader";

type AppProps = {
  branchOption: SelectOption[];
  fetching: boolean;
  checkStockItemTypeBottom: () => void;
  setStockItemText: React.Dispatch<React.SetStateAction<string>>;
  outputData: BomOutputType[] | [];
  addMoreData: (type: string) => void;
  currencySign: string | undefined;
  bomHeaderData: BomHeaderType;
  templateId?: string;
  allStockItemOption: SelectOption[];
  deleteData: (type: string, index: number) => void;
  handleInputChange: (
    e: any,
    type: string,
    inputType: string,
    index: number
  ) => void;
  handletoggleRowInput: (item: number, data: any) => void;
  handleGetSelectedbatch: (data1: any, data2: any, type: string) => void;
  autoUniqueNumberGenerationData: any;
  toggleExpandCollapseItems: (type: string, action: string) => void;
  batchFetching:boolean;
  isMenuOpen:boolean;
};

const OutputGoods = ({
  outputData,
  addMoreData,
  deleteData,
  fetching,
  templateId,
  currencySign,
  checkStockItemTypeBottom,
  setStockItemText,
  bomHeaderData,
  branchOption,
  allStockItemOption,
  handleInputChange,
  handletoggleRowInput,
  handleGetSelectedbatch,
  autoUniqueNumberGenerationData,
  toggleExpandCollapseItems,
  batchFetching,
  isMenuOpen
}: AppProps) => {



  return (
    <div>

<div className="d-flex justify-content-between">
      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
        <div className="sub-header">OTHER OUTPUT ITEM</div>
        {!templateId ? <BomAddMore
          addMoreData={addMoreData}
          type="OutputGoods"
          data={outputData}
        /> : null}
        
      </div>
      {autoUniqueNumberGenerationData?.is_enable === 1 ?
        <div className="d-flex align-items-center mr-3" style={{ gap: "30px" }}>
          <p className="batchExpandAll" onClick={() => toggleExpandCollapseItems("output", "expand")}>
            Expand All
          </p>
          <p className="batchExpandAll" onClick={() => toggleExpandCollapseItems("output", "collapse")}>
            Collapse All
          </p>
        </div>
        :""}
      </div>

      <table className="table">
        <thead className="thead-slight">
          <BomTableheader tableHeader={OutputGoodsHeaders} />
        </thead>

        <BomTableData
          allStockItemOption={allStockItemOption}
          branchOption={branchOption}
          data={outputData}
          currencySign={currencySign}
          fetching={fetching}
          templateId={templateId}
          bomHeaderData={bomHeaderData}
          checkStockItemTypeBottom={checkStockItemTypeBottom}
          setStockItemText={setStockItemText}
          headers={OutputGoodsHeaders}
          deleteData={deleteData}
          type="OutputGoods"
          toggleRow={handletoggleRowInput}
          handleInputChange={handleInputChange}
          handleGetSelectedbatch={handleGetSelectedbatch}
          autoUniqueNumberGenerationData={autoUniqueNumberGenerationData}
          batchFetching={batchFetching}
          isMenuOpen={isMenuOpen}
        />
      </table>
    </div>
  );
};

export default OutputGoods;
